/* eslint-disable max-len */
/* eslint-disable import/prefer-default-export */
import { useQuery } from '@tanstack/react-query';
// Services
import { getConfiguration } from './configurationService';

/**
 * @description useQuery Hook to get the remote working configuration.
 * @param {Object} options useQuery Options
 * @returns {import('@tanstack/react-query').UseQueryResult<import('../types').Configuration, Error>}
 */
export const useConfigurationQuery = (options) => useQuery({
  queryKey: ['configuration'],
  queryFn: () => getConfiguration(),
  ...options,
});
